import { PayloadAction, createSlice } from "@reduxjs/toolkit"

type IAuthSlice = {
  isAuthenticated: boolean
  token: string | null
  initPath: string
  customerId: string
  phoneNumber: string
}

const initialState: IAuthSlice = {
  isAuthenticated: false,
  token: null,
  initPath: "/",
  customerId: "",
  phoneNumber: "",
}

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
      state.isAuthenticated = true
    },
    setInitPath: (state, action: PayloadAction<string>) => {
      state.initPath = action.payload
    },
    setCustomerId: (state, action: PayloadAction<string>) => {
      state.customerId = action.payload
    },
    setPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload
    },
  },
})

export const {
  setIsAuthenticated,
  setToken,
  setInitPath,
  setCustomerId,
  setPhoneNumber,
} = authSlice.actions

export default authSlice.reducer
